module.exports = __webpack_public_path__ + "img/TasksList1.21f4411a.png";